export const SET_FILTERS = 'SET_FILTERS';

export type FILTERS_TYPE = {
  title: string;
  key: string;
  options: ({ label: string; value: string } | string)[];
}[];
